import type { ContactsAsUsers } from './contacts-as-users';

export function contactNamesWithPartnerNames(contactUuids: string[], contactsAsUsers: ContactsAsUsers[]): string[] {
  return contactsAsUsers
    .filter((c) => {
      return contactUuids.indexOf(c.uuid) > -1;
    })
    .map((c) => {
      return c.name + ' (' + c.partnerName + ')';
    });
}
